import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadablePartnerOnboardingSigninRedirect = Loadable({
  loader: function loader() {
    return import('../PartnerOnboardingSigninRedirect.jsx');
  },
  loading: ComponentLoading
});
export default LoadablePartnerOnboardingSigninRedirect;